<template>
  <div class="bg-midnight min-h-screen text-white relative">
    <!-- Three.js Background -->
    <FireworksCanvas />

    <!-- Content Overlay -->
    <div class="relative z-10">
      <Navbar />

      <main>
        <router-view v-slot="{ Component }">
          <transition name="fade" mode="out-in">
            <component :is="Component" />
          </transition>
        </router-view>
      </main>

      <FooterSection />
    </div>

    <!-- Cart Drawer (z-50, above everything) -->
    <CartDrawer />

    <!-- Mobile Navigation -->
    <MobileNav />

    <!-- Global Auth Modal -->
    <AuthModal :isOpen="auth.showLoginModal" @close="auth.showLoginModal = false" />

    <!-- Background Gradient Orbs -->
    <div class="fixed top-0 right-0 w-96 h-96 bg-fire-gold/5 blur-3xl -z-10 rounded-full translate-x-1/2 -translate-y-1/2 pointer-events-none"></div>
    <div class="fixed bottom-0 left-0 w-80 h-80 bg-red-900/10 blur-3xl -z-10 rounded-full -translate-x-1/2 translate-y-1/2 pointer-events-none"></div>
  </div>
</template>

<script setup>
import Navbar from './components/Navbar.vue';
import FireworksCanvas from './components/FireworksCanvas.vue';
import FooterSection from './components/FooterSection.vue';
import CartDrawer from './components/CartDrawer.vue';
import MobileNav from './components/MobileNav.vue';
import AuthModal from './components/AuthModal.vue';
import { useAuthStore } from './stores/auth';

const auth = useAuthStore();
</script>

<style>
body {
  margin: 0;
  padding: 0;
  -webkit-font-smoothing: antialiased;
  font-family: 'Outfit', sans-serif;
}

.fade-enter-active,
.fade-leave-active { transition: opacity 0.35s ease, transform 0.35s ease; }
.fade-enter-from { opacity: 0; transform: translateY(12px); }
.fade-leave-to { opacity: 0; transform: translateY(-8px); }
</style>
